/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import PasswordSettings from "./PasswordSettings";
import { useCityContext } from "../../context/levels";
import { useCompanyContext } from "../../context/CompanyContext";
import { useAdminContext } from "../../context/admin/AdminContext";
import {
  getOneAdmin,
  pushCountry,
} from "../../lib/sysNavigation/SysNavigation";
import { requireFields } from "../../lib/validators";
import { useAdminsContext } from "../../context/admin/AdminManageContext";
import { useCountryContext } from "../../context/CountryContext";
import {
  MyMessage,
  InputField,
  PhoneInput,
  SelectInput,
  SearchSelectInput,
  AddPageShell,
  AddSection,
} from "../components/Component";
import { roles } from "./roles";
import { countriesList } from "../components/data";
import { HiOutlineUserAdd } from "react-icons/hi";
import {
  FiUser,
  FiMapPin,
  FiShield,
  FiMail,
  FiBriefcase,
  FiLock,
  FiHash,
  FiCalendar,
  FiHome,
} from "react-icons/fi";

const Edit = () => {
  const { sysAdmin } = useAdminContext();
  const currentRole = sysAdmin?.role;

  const { setCompany } = useCompanyContext();
  const { cities, fetchCities } = useCityContext();
  const { countries, fetchCountries } = useCountryContext();
  const { updateProfile, setAdmins } = useAdminsContext();

  const admin = getOneAdmin();
  const admin_id = admin?.admin_id;
  const company = admin?.company;

  const [error, setError] = useState(false);
  const [message, setErrorMessage] = useState("");
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);

  const [first_name, setFirstName] = useState(admin?.first_name);
  const [last_name, setLastName] = useState(admin?.last_name);
  const [email, setEmail] = useState(admin?.email);
  const [phone, setPhone] = useState(admin?.phonenumber);
  const [country, setCountry] = useState(admin?.country);
  const [city, setCity] = useState(admin?.city);
  const [address, setAddress] = useState(admin?.address);
  const [role, setRole] = useState(admin?.role);
  const [adminStatus, setAdminStatus] = useState(admin?.active);

  const [password, setPassword] = useState(null);
  const [confirm_password, setConfirmPassword] = useState(null);
  const [action, setAction] = useState("profile");

  const adminRoutes = "/admin";

  useEffect(() => {
    if (!cities) fetchCities(1, 2000);
    if (!countries) fetchCountries();
  }, [cities, countries, country]);

  const responses = (err: any, msg: any) => {
    setLoading(false);
    setError(err);
    setSuccess(!err);
    setErrorMessage(msg);
  };

  const updateAdminHandler = async (e: any) => {
    e.preventDefault();
    setLoading(true);
    const { isError, message } = requireFields({
      "First Name": first_name,
      "Last Name": last_name,
      Phone: phone,
      Email: email,
      Address: address,
      Country: country,
      City: city,
    });
    if (isError) responses(true, message);
    else await sendProfileRequest();
  };

  const sendProfileRequest = async () => {
    const data = {
      email,
      first_name,
      last_name,
      phonenumber: phone,
      country,
      city,
      address,
      role: String(role)?.toLowerCase()?.replaceAll(" ", "_"),
      active: adminStatus,
    };

    const { message, status } = await updateProfile(admin_id, data);
    if (status === 200 || status === 201) {
      setAdmins(null);
      setCompany(null);
      responses(false, message);
    } else {
      responses(true, message);
    }
  };

  const citiesFilter = () => {
    const getId = ({ data, key, value, obj_id }: any) =>
      data?.find((x: any) => x?.[key] === value)?.[obj_id] || null;

    const id = getId({
      key: "name",
      value: country,
      data: countries,
      obj_id: "country_id",
    });

    return cities
      ?.filter((x: any) => x?.country_id === id)
      .map((y: any) => y?.name);
  };

  const fullName =
    [first_name, last_name].filter(Boolean).join(" ") || "Unnamed admin";
  const initials =
    `${(first_name || "?").charAt(0)}${(last_name || "").charAt(0)}`
      .toUpperCase() || "AD";
  const roleLabel = role
    ? String(role).toLowerCase().replaceAll("_", " ")
    : "content creator";
  const isActive = adminStatus === 1;
  const createdAt = admin?.createdAt
    ? new Date(admin.createdAt).toLocaleDateString(undefined, {
        year: "numeric",
        month: "short",
        day: "numeric",
      })
    : null;
  const locationLabel = [city, country].filter(Boolean).join(", ");

  return (
    <>
      <AddPageShell
        backRoute={adminRoutes}
        eyebrow="Team • Admins"
        title={fullName}
        subtitle={
          email
            ? `${email} · update profile, access and security.`
            : "Update profile, access and security."
        }
        icon={<HiOutlineUserAdd className="h-5 w-5" />}
        pills={[
          { label: "Role", value: roleLabel },
          { label: "Status", value: isActive ? "Active" : "Blocked" },
          ...(company?.name
            ? [{ label: "Company", value: company.name }]
            : []),
        ]}
        loading={action === "profile" ? loading : false}
        submitLabel="Save Changes"
        submitHelper="Save profile, then update password below if needed."
        onSubmit={updateAdminHandler}
        onSubmitClick={() => {
          setAction("profile");
          setError(false);
          setSuccess(false);
          setErrorMessage(null);
        }}
        message={
          <MyMessage
            error={error}
            message={message}
            success={success}
            onExpired={() => {
              setError(false);
              setSuccess(false);
            }}
            onClick={() => {
              setError(false);
              setSuccess(false);
              setErrorMessage("");
            }}
          />
        }
      >
        {/* Profile preview card */}
        <section
          id="profile"
          className="scroll-mt-24 overflow-hidden rounded-2xl border border-gray-200 bg-white shadow-sm"
        >
          <div className="flex flex-col gap-5 px-5 py-5 sm:flex-row sm:items-center sm:justify-between sm:px-7">
            <div className="flex items-center gap-4">
              <span
                aria-hidden
                className="grid h-16 w-16 shrink-0 place-items-center rounded-2xl bg-brand text-xl font-semibold text-white shadow-sm ring-1 ring-brand/30"
              >
                {initials}
              </span>
              <div className="min-w-0">
                <p className="truncate text-base font-semibold text-gray-900">
                  {fullName}
                </p>
                <p className="mt-0.5 text-[11px] font-semibold uppercase tracking-[0.14em] text-gray-500">
                  Admin profile
                </p>
                <div className="mt-2 flex flex-wrap items-center gap-2">
                  <span className="inline-flex items-center gap-1.5 rounded-full border border-gray-200 bg-white px-2.5 py-1 text-[11px] font-semibold text-gray-700">
                    <span
                      aria-hidden
                      className={[
                        "inline-block h-1.5 w-1.5 rounded-full",
                        isActive ? "bg-brand" : "bg-gray-400",
                      ].join(" ")}
                    />
                    {isActive ? "Active" : "Blocked"}
                  </span>
                  <span className="inline-flex items-center gap-1.5 rounded-full border border-gray-200 bg-white px-2.5 py-1 text-[11px] font-semibold capitalize text-gray-700">
                    <FiShield className="h-3.5 w-3.5 text-gray-500" />
                    {roleLabel}
                  </span>
                </div>
              </div>
            </div>
          </div>

          {/* Stats strip */}
          <div className="grid grid-cols-2 divide-y divide-gray-100 border-t border-gray-100 sm:grid-cols-4 sm:divide-x sm:divide-y-0">
            {[
              {
                icon: <FiHash className="h-3.5 w-3.5" />,
                label: "Admin ID",
                value: admin_id ? `#${admin_id}` : "—",
                mono: true,
              },
              {
                icon: <FiMail className="h-3.5 w-3.5" />,
                label: "Email",
                value: email || "—",
              },
              {
                icon: <FiHome className="h-3.5 w-3.5" />,
                label: "Location",
                value: locationLabel || "—",
              },
              {
                icon: <FiCalendar className="h-3.5 w-3.5" />,
                label: "Joined",
                value: createdAt || "—",
              },
            ].map((s, i) => (
              <div key={i} className="px-4 py-3 sm:px-5">
                <div className="flex items-center gap-1.5 text-[10px] font-semibold uppercase tracking-[0.14em] text-gray-500">
                  {s.icon}
                  {s.label}
                </div>
                <p
                  className={[
                    "mt-1 truncate text-[12px] font-semibold text-gray-900",
                    s.mono ? "tabular-nums" : "",
                  ].join(" ")}
                  title={String(s.value)}
                >
                  {s.value}
                </p>
              </div>
            ))}
          </div>

          {company?.name ? (
            <div className="flex items-center gap-2 border-t border-gray-100 bg-gray-50 px-5 py-2.5 text-[11px] font-medium text-gray-600">
              <FiBriefcase className="h-3.5 w-3.5 text-gray-500" />
              <span>Linked to</span>
              <span className="font-semibold capitalize text-gray-900">
                {company.name}
              </span>
            </div>
          ) : null}
        </section>

        <AddSection
          id="identity"
          title="Identity"
          hint="Basic details used across the dashboard."
          icon={<FiUser className="h-4 w-4" />}
        >
          <div className="grid grid-cols-1 gap-4 md:grid-cols-2 xl:grid-cols-3">
            <InputField
              props={{
                id: "firstname",
                title: "First Name",
                type: "text",
                value: first_name || "",
                onChange: (e: any) => {
                  setFirstName(e.target.value);
                  setError(null);
                  setSuccess(null);
                },
              }}
            />
            <InputField
              props={{
                id: "lastname",
                title: "Last Name",
                type: "text",
                value: last_name || "",
                onChange: (e: any) => {
                  setLastName(e.target.value);
                  setError(null);
                  setSuccess(null);
                },
              }}
            />
            <InputField
              props={{
                id: "email",
                title: "Email Address",
                type: "email",
                value: email || "",
                onChange: (e: any) => {
                  setEmail(e.target.value);
                  setError(null);
                  setSuccess(null);
                },
              }}
            />
            <PhoneInput
              setPhone={setPhone}
              phone={phone}
              required={true}
              country={country || ""}
            />
          </div>
        </AddSection>

        <AddSection
          id="location"
          title="Location"
          hint="Country, city and address for localised permissions and content."
          icon={<FiMapPin className="h-4 w-4" />}
        >
          <div className="grid grid-cols-1 gap-4 md:grid-cols-2 xl:grid-cols-3">
            <SearchSelectInput
              title="Country"
              value={country || null}
              preselect={
                country !== null && country !== undefined
                  ? [{ name: country }]
                  : null
              }
              options={countries ? countries?.map((x: any) => x?.name) : []}
              onChange={(country: any) => {
                setCountry(country);
                const pickedCountry = countriesList?.find(
                  (_c: any) => _c.name === country,
                );
                pushCountry({
                  country: {
                    id: pickedCountry?.id,
                    name: pickedCountry?.name,
                    slug: pickedCountry?.name,
                    route: "/admin",
                  },
                });
                setCity(null);
              }}
            />
            <SearchSelectInput
              title="City"
              setValue={setCity}
              value={city || null}
              preselect={
                city !== null && city !== undefined ? [{ name: city }] : null
              }
              options={
                cities
                  ? country && !city
                    ? citiesFilter()
                    : cities?.map((x: any) => x?.name)
                  : []
              }
              onChange={(city: any) => setCity(city)}
            />
            <InputField
              props={{
                id: "address",
                title: "Address",
                type: "text",
                value: address || "",
                onChange: (e: any) => {
                  setAddress(e.target.value);
                  setError(null);
                  setSuccess(null);
                },
              }}
            />
          </div>
        </AddSection>

        <AddSection
          id="access"
          title="Access & Status"
          hint="Control admin privileges and account state."
          icon={<FiShield className="h-4 w-4" />}
        >
          <div className="grid grid-cols-1 gap-4 md:grid-cols-2 xl:grid-cols-3">
            <SelectInput
              title="Admin Status"
              options={["unblocked", "blocked"]}
              defaultValue={adminStatus === 1 ? "unblocked" : "blocked"}
              onChange={(e: any) => {
                setAdminStatus(e.target.value === "unblocked" ? 1 : 0);
                setError(null);
                setSuccess(null);
              }}
            />
            <SelectInput
              title="Admin Role"
              defaultValue={
                role
                  ? String(role)?.toLowerCase()?.replaceAll("_", " ")
                  : "content_creator"
              }
              options={roles(currentRole)}
              onChange={(e: any) => {
                setRole(e.target.value);
                setError(null);
                setSuccess(null);
              }}
            />
            {company?.name ? (
              <div className="flex flex-col">
                <span className="mb-1 text-[11px] font-bold text-gray-700">
                  Company
                </span>
                <span className="inline-flex h-[42px] items-center gap-2 rounded-lg border border-gray-200 bg-gray-50 px-3 text-[12px] font-semibold capitalize text-gray-700">
                  <FiBriefcase className="h-3.5 w-3.5 text-gray-500" />
                  {company.name}
                </span>
              </div>
            ) : null}
          </div>
        </AddSection>

        <AddSection
          id="security"
          title="Password & Security"
          hint="Update the password regularly to keep the account secure."
          icon={<FiLock className="h-4 w-4" />}
        >
          <PasswordSettings
            password={password}
            setError={setError}
            setAction={setAction}
            responses={responses}
            setSuccess={setSuccess}
            setLoading={setLoading}
            setPassword={setPassword}
            setErrorMessage={setErrorMessage}
            confirm_password={confirm_password}
            setConfirmPassword={setConfirmPassword}
            loading={action === "password" ? loading : false}
          />
        </AddSection>
      </AddPageShell>
    </>
  );
};

export default Edit;
